import useSWRMutation from 'swr/mutation';
import { DCreateCustomerMessage } from '../data/dtos/message';
import { marketplaceChatService } from '../services/marketplace';

export function useCreateMarketplaceCustomerMessage({
  userId,
  conversationId,
}: Pick<DCreateCustomerMessage, 'userId' | 'conversationId'>) {
  const execute = async (
    input: Omit<DCreateCustomerMessage, 'userId' | 'conversationId'>
  ) => {
    return await marketplaceChatService.sendCustomerMessage({
      userId,
      conversationId,
      ...input,
      content: input.content?.trim() ?? null,
    });
  };

  const fetchKey = 'send-marketplace-customer-message';
  const { trigger, error, isMutating } = useSWRMutation(
    fetchKey,
    async (
      _,
      {
        arg,
      }: {
        arg: Omit<DCreateCustomerMessage, 'userId' | 'conversationId'>;
      }
    ) => await execute(arg)
  );

  return {
    trigger,
    error,
    isLoading: isMutating,
  };
}
